import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { formatPrice } from "../lib/api";
import { useWishlist } from "../lib/wishlist";

const PLACEHOLDER =
  "/brand/cover-placeholder.png";

function isWithinDays(iso, days) {
  if (!iso) return false;
  try {
    const t = new Date(iso).getTime();
    return Date.now() - t < days * 24 * 60 * 60 * 1000;
  } catch { return false; }
}

export default function VinylCard({ item, showNew = true }) {
  const cover = item.cover_image || item.thumb || PLACEHOLDER;
  const to = `/catalogo/${item.slug}`;
  const { has, toggle } = useWishlist();
  const fav = has(item.listing_id);
  const isNew = showNew && isWithinDays(item.posted, 7);

  const handleHeart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(item.listing_id);
  };

  return (
    <Link
      to={to}
      className="group flex flex-col gap-2.5"
      data-testid={`vinyl-card-${item.slug}`}
    >
      <div className="relative aspect-square overflow-hidden bg-[hsl(var(--muted))]">
        <img
          src={cover}
          alt={`${item.artist} — ${item.title}`}
          loading="lazy"
          className="object-cover w-full h-full transition-opacity duration-200 group-hover:opacity-90"
        />

        {isNew && (
          <span
            className="absolute top-2 left-2 bg-foreground text-background text-[10px] uppercase tracking-wider px-1.5 py-0.5"
            data-testid={`vinyl-card-new-${item.slug}`}
          >
            Nuevo
          </span>
        )}

        <button
          type="button"
          onClick={handleHeart}
          aria-label={fav ? "Quitar de favoritos" : "Añadir a favoritos"}
          className="absolute top-2 right-2 grid place-items-center w-8 h-8 bg-background/90 hover:bg-background border border-border/60 transition-colors"
          data-testid={`vinyl-card-fav-${item.slug}`}
        >
          <Heart
            size={14}
            className={fav ? "fill-[hsl(var(--accent))] text-[hsl(var(--accent))]" : "text-foreground"}
          />
        </button>
      </div>

      <div className="flex flex-col gap-0.5 text-sm">
        <span className="text-xs text-muted-foreground line-clamp-1">{item.artist}</span>
        <span className="text-sm font-medium leading-tight line-clamp-2 group-hover:text-[hsl(var(--accent))] transition-colors">
          {item.title}
        </span>
        <div className="flex items-baseline justify-between mt-1 text-xs">
          <span className="text-muted-foreground line-clamp-1">
            {[item.format, item.year].filter(Boolean).join(" · ")}
          </span>
          <span className="text-foreground font-medium tabular-nums">
            {formatPrice(item.price, item.currency)}
          </span>
        </div>
      </div>
    </Link>
  );
}
